import type {
  HorizontalPositionEnum,
  VerticalPositionEnum,
} from '@maestro/commerce-blocks/components/notification/notification.types'

import { useMemo } from 'react'

import { useNotificationContext } from '@maestro/commerce-blocks/components/notification/notification.context'
import { theme } from '@maestro/local/theme'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

export const useNotificationContainer = () => {
  const { toasts, removeToast } = useNotificationContext()
  const { toastContainerRef } = useModals()

  const { horizontal, vertical } = theme().notification as {
    horizontal: HorizontalPositionEnum
    vertical: VerticalPositionEnum
  }

  const hasToasts = useMemo(() => toasts.length > 0, [toasts])

  return {
    horizontal,
    removeToast,
    toasts,
    toastContainerRef,
    vertical,
    hasToasts,
  }
}
